<template>
  <div class="calendars-bulk text-dark">
    <div class="sub-header no-print">
      <p class="sub-header__item sub-header__title">{{ $t('vue2.calendars.calendars') }}
        <span class="sub-header__title-divider icon-arrow-right4"></span>
      </p>
      <p class="sub-header__item" @click="selectedView = 'crudCalendars'"
         :class="{'sub-header__item--active': selectedView === 'crudCalendars'}">{{
          $t('vue2.calendars.edit_calendars')
        }}</p>
      <p class="sub-header__item" @click="selectedView = 'copyCalendars'"
         :class="{'sub-header__item--active': selectedView === 'copyCalendars'}">{{
          $t('vue2.calendars.copy_calendars')
        }}
      </p>
      <p class="sub-header__item" @click="selectedView = 'presence'" v-if="userHasPermissionToEditOthersPresence"
         :class="{'sub-header__item--active': selectedView === 'presence'}">
        {{ $t('vue2.calendars.add_presence') }}
      </p>
      <p class="sub-header__item" @click="selectedView = 'deleteDays'"
         :class="{'sub-header__item--active': selectedView === 'deleteDays'}">
        {{ $t('vue2.calendars.delete_events_in_date_range') }}
      </p>
    </div>
    <div class="grid grid-pad min-height">
      <div class="calendars-bulk__header">
        <div class="calendars-bulk__header__left">
          <h1 class="marg-20-right text-dark">{{ $t('vue2.calendars.calendars') }}</h1>
          <ChangeSchoolYear :whiteTheme="true"></ChangeSchoolYear>
        </div>
        <div class="calendars-bulk__header__right">
          <Datepickerrange
            v-if="selectedView === 'deleteDays'"
            :allow-same-date="true"
            :startdate="fromDate"
            :enddate="toDate"
            @startchanged="setFromDate"
            @endchanged="setToDate">
          </Datepickerrange>
        </div>
      </div>
      <template v-if="selectedView === 'crudCalendars'">
        <CalendarsBulkArchiveCalendar :calendars="klassCalendars" calType="klass"
                                      :isOpen="true"></CalendarsBulkArchiveCalendar>
        <CalendarsBulkArchiveCalendar :calendars="roomCalendarsInclArchived"
                                      calType="room"></CalendarsBulkArchiveCalendar>
        <CalendarsBulkArchiveCalendar :calendars="mergeCalendarsInclArchived"
                                      calType="merge"></CalendarsBulkArchiveCalendar>
        <CalendarsBulkArchiveCalendar :calendars="otherCalendars" calType="other"></CalendarsBulkArchiveCalendar>
      </template>
      <template v-if="selectedView === 'copyCalendars'">
        <CopyMultipleCalendars :calendars="klassCalendars" calType="klass" :isOpen="true"></CopyMultipleCalendars>
        <CopyMultipleCalendars :calendars="userCalendars" calType="user"></CopyMultipleCalendars>
        <CopyMultipleCalendars :calendars="roomCalendarsInclArchived" calType="room"></CopyMultipleCalendars>
        <CopyMultipleCalendars :calendars="mergeCalendarsInclArchived" calType="merge"></CopyMultipleCalendars>
        <CopyMultipleCalendars :calendars="otherCalendars" calType="other"></CopyMultipleCalendars>
      </template>
      <template v-if="selectedView === 'presence'">
        <PresenceForUsers></PresenceForUsers>
      </template>
      <template v-if="selectedView === 'deleteDays'">
        <CalendarsDeleteEventsInDays
          v-if="klassCalendars.length > 0"
          :fromDate="fromDate"
          :toDate="toDate"
          :calendars="klassCalendars"
          calType="klass"
          :isOpen="false">
        </CalendarsDeleteEventsInDays>
        <CalendarsDeleteEventsInDays
          v-if="kindergartenCalendars.length > 0"
          :fromDate="fromDate"
          :toDate="toDate"
          :calendars="kindergartenCalendars"
          calType="Stuer"
          :isOpen="true">
        </CalendarsDeleteEventsInDays>
        <CalendarsDeleteEventsInDays
          :fromDate="fromDate"
          :toDate="toDate"
          :calendars="userCalendars"
          calType="user"
          :isOpen="false">
        </CalendarsDeleteEventsInDays>
        <CalendarsDeleteEventsInDays
          :fromDate="fromDate"
          :toDate="toDate"
          :calendars="roomCalendarsInclArchived"
          calType="room"
          :isOpen="false">
        </CalendarsDeleteEventsInDays>
        <CalendarsDeleteEventsInDays
          :fromDate="fromDate"
          :toDate="toDate"
          :calendars="otherCalendars"
          calType="other"
          :isOpen="false">
        </CalendarsDeleteEventsInDays>
      </template>
    </div>
  </div>
</template>

<script>
import CopyMultipleCalendars from '../CopyCalendar/CopyMultipleCalendars'
import CalendarsBulkArchiveCalendar from './CalendarsBulkArchiveCalendar'
import ChangeSchoolYear from '../School/ChangeSchoolYear'
import eventbus from '../../eventbus'
import Print from '../PrintCalendars/Print'
import PresenceForUsers from '../Presence/PresenceForUsers'
import Datepickerrange from '../datepicker/DatePickerRange'
import moment from 'moment'
import CalendarsDeleteEventsInDays from './CalendarsDeleteEventsInDays'

export default {
  components: {
    CalendarsDeleteEventsInDays,
    Datepickerrange,
    PresenceForUsers, Print, CopyMultipleCalendars, CalendarsBulkArchiveCalendar, ChangeSchoolYear
  },
  data () {
    return {
      selectedView: 'crudCalendars',
      fromDate: moment(),
      toDate: moment()
    }
  },
  computed: {
    klassCalendars () {
      return this.$store.getters.klassCalendars
    },
    kindergartenCalendars () {
      return this.$store.getters.kindergartenCalendars
    },
    userCalendars () {
      return this.$store.getters.userCalendars
    },
    roomCalendarsInclArchived () {
      return this.$store.getters.roomCalendarsInclArchived
    },
    mergeCalendarsInclArchived () {
      return this.$store.getters.mergeCalendarsInclArchived
    },
    otherCalendars () {
      return this.$store.getters.otherCalendars
    },
    isSchoolDanish () {
      return window.SCHOOL.country.toLowerCase() === 'dk'
    },
    user () {
      return this.$store.state.user
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    userHasPermissionToEditOthersPresence () {
      return this.userHasPermission('can_edit_others_presence')
    }
  },
  methods: {
    setFromDate (date) {
      this.setDates(date, null)
    },
    setToDate (date) {
      this.setDates(null, date)
    },
    setDates (start, end) {
      if (start) {
        this.fromDate = start
      }
      if (end) {
        this.toDate = end
      }
    },
    userHasPermission (val) {
      if (!this.user) {
        return false
      }
      if (this.isPermissionsActivatedForSchool) {
        return this.userPermissions.indexOf(val) > -1 || this.user.admin
      } else {
        return true
      }
    },
    setSelectedView (val) {
      if (val === 'printCalendars') {
        this.selectedView = 'printCalendars'
        setTimeout(_ => {
          this.setIsPrintCalendarsModal()
        }, 0)
      }
    },
    setIsPrintCalendarsModal () {
      eventbus.isPrintCalendarsModal = true
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.sub-header {
  height: 40px;
  border-bottom: solid 1px #CCCCCC;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
}

.sub-header__title-divider {
  margin-left: 20px;
}

.sub-header__item.sub-header__title {
  cursor: default;
}

.sub-header__item {
  font-weight: bold;
  margin: 0 20px;
  display: flex;
  align-items: center;
  font-size: 11px;
  color: #3e4450;
  opacity: 0.7;
  text-transform: uppercase;
  border-bottom: 2px solid transparent;
  border-top: 2px solid transparent;
  cursor: pointer;
}

.sub-header__item.sub-header__item--active {
  opacity: 1;
  border-bottom: 2px solid var(--blue);
}

.calendars-bulk__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  margin-top: 0;
}

.calendars-bulk__header > div {
  display: flex;
  align-items: center;
}

.calendars-bulk__header h1 {
  margin: 0 20px 0 0;
}

.min-height {
  min-height: 800px;
}
</style>



// WEBPACK FOOTER //
// CalendarsBulk.vue?5551ae34